/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

/*
 * L'inventario e' indirizzato per cliente anche qui, con lo stesso URL che usa
 * l'admin: il backend rifiuta comunque un id che non sia il proprio, ma tenere
 * un solo formato di rotta evita due strade diverse per la stessa cosa.
 */
export const inventarioAPI = {
  list: async (clienteId, params = {}) => {
    const { data } = await apiClient.get(`/inventario/${clienteId}`, { params });
    return data;
  },

  riepilogo: async (clienteId) => {
    const { data } = await apiClient.get(`/inventario/${clienteId}/riepilogo`);
    return data;
  },

  categorie: async (clienteId) => {
    const { data } = await apiClient.get(`/inventario/${clienteId}/categorie`);
    return data;
  },

  crea: async (clienteId, payload) => {
    const { data } = await apiClient.post(`/inventario/${clienteId}`, payload);
    return data;
  },

  modifica: async (articoloId, payload) => {
    const { data } = await apiClient.put(`/inventario/articolo/${articoloId}`, payload);
    return data;
  },

  // tipo: 'carico' | 'scarico' | 'rettifica'
  movimento: async (articoloId, payload) => {
    const { data } = await apiClient.post(`/inventario/articolo/${articoloId}/movimento`, payload);
    return data;
  },

  movimenti: async (articoloId) => {
    const { data } = await apiClient.get(`/inventario/articolo/${articoloId}/movimenti`);
    return data;
  },

  archivia: async (articoloId, attivo) => {
    const { data } = await apiClient.patch(`/inventario/articolo/${articoloId}/attivo`, { attivo });
    return data;
  },

  // Cancellazione definitiva: porta via anche il registro dei movimenti.
  // L'archiviazione resta la strada normale, questa e' per gli sbagli.
  elimina: async (articoloId) => {
    const { data } = await apiClient.delete(`/inventario/articolo/${articoloId}`);
    return data;
  },
};
